import { useEffect, useState } from 'react';

import { fetchPreDiabetesQuestions } from '@/modules/api';
import type { SurveyQuestion } from '@/modules/survey';

type UsePreDiabetesQuestions = {
  questions: SurveyQuestion[];
  isLoading: boolean;
  error: unknown;
};

// Fetches the pre-diabetes questions and maps them to the shared SurveyQuestion
// shape. Choices keep their `order` (the jumpToIf condition keys off it) and
// carry `surveyChoiceUrn` as the submit value.
export function usePreDiabetesQuestions(): UsePreDiabetesQuestions {
  const [questions, setQuestions] = useState<SurveyQuestion[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    let cancelled = false;
    fetchPreDiabetesQuestions()
      .then((items) => {
        if (cancelled) return;
        setQuestions(
          items.map((question) => ({
            key: question.key,
            order: question.order,
            text: question.text,
            additionalInfo: question.additionalInfo,
            choices: question.choices.map((choice) => ({
              text: choice.text,
              order: choice.order,
              surveyChoiceUrn: choice.surveyChoiceUrn,
            })),
          }))
        );
        setIsLoading(false);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(err);
        setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { questions, isLoading, error };
}
